import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

// Definimos las props del componente
interface CyberButtonProps {
    children: React.ReactNode;
    variant?: 'cyan' | 'magenta' | 'outline';
    size?: 'small' | 'medium' | 'large';
    to?: string;
    onClick?: () => void;
    className?: string;
    type?: 'button' | 'submit' | 'reset';
    disabled?: boolean;
}

const CyberButton: React.FC<CyberButtonProps> = ({
                                                     children,
                                                     variant = 'cyan',
                                                     size = 'medium',
                                                     to,
                                                     onClick,
                                                     className = '',
                                                     type = 'button',
                                                     disabled = false,
                                                     ...props
                                                 }) => {
    const baseClasses = `cyber-button cyber-button--${variant} cyber-button--${size} ${className}`;

    const buttonContent = (
        <motion.span
            className="cyber-button__content"
            whileHover={!disabled ? { scale: 1.05 } : {}}
            whileTap={!disabled ? { scale: 0.95 } : {}}
        >
            {children}
            <span className="cyber-button__glow"></span>
            <span className="cyber-button__border"></span>
        </motion.span>
    );

    // Si tiene prop 'to', renderiza como Link
    if (to) {
        return (
            <Link to={to} className={baseClasses} {...props}>
                {buttonContent}
            </Link>
        );
    }

    // Si no tiene 'to', renderiza como button
    return (
        <motion.button
            className={baseClasses}
            onClick={onClick}
            type={type}
            disabled={disabled}
            whileHover={!disabled ? { scale: 1.02 } : {}}
            whileTap={!disabled ? { scale: 0.98 } : {}}
            {...props}
        >
            {buttonContent}
        </motion.button>
    );
};

export default CyberButton;